import { Module } from 'vuex';

import { RootState } from '@/store';
import { User, ChangePasswordOptions, UserRoleType } from '@/services/users/users.types';
import { usersService } from '@/services/users/users.service';
import { dicoLabelsService } from '@/services/dico-labels/dico-labels.service';
import { checkUserAccess } from '@/utils/users/check-user-access';

export interface UserState {
  authenticatedUser: User;
  authenticatedUserLoading: boolean;
  // user: User;
  // userLoading: boolean;
}

const state: UserState = {
  authenticatedUser: null,
  authenticatedUserLoading: false
  // user: null,
  // userLoading: false
};

const options: Module<UserState, RootState> = {
  namespaced: true,
  state: () => state,
  actions: {
    getAuthenticatedUser: ({ commit, dispatch }): Promise<void> => {
      commit('authenticatedUserLoading', true);
      return usersService
        .getAuthenticatedUser()
        .then(user => user && commit('authenticatedUser', user))
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('authenticatedUserLoading', false));
    },
    setUser: ({ commit, dispatch }, user: User | string | number): Promise<void> => {
      if (typeof user === 'number' || typeof user === 'string') return dispatch('getUser', user);
      else commit('user', user);
    },
    getUser: ({ commit, dispatch }, userId: number): Promise<void> => {
      commit('user', null);
      commit('userLoading', true);
      return usersService
        .get(userId)
        .then(user => user && commit('user', user))
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('userLoading', false));
    },
    changePassword: ({ dispatch }, params: ChangePasswordOptions): Promise<void> => {
      return usersService
        .changePassword(state.authenticatedUser.id, params)
        .then(() => dispatch('alert/pushSuccess', 'Le mot de passe a bien été modifié', { root: true }))
        .catch(error => dispatch('alert/pushError', error, { root: true }));
    }
  },
  mutations: {
    authenticatedUser: (state, user) => (state.authenticatedUser = user),
    authenticatedUserLoading: (state, loading) => (state.authenticatedUserLoading = loading)
    // user: (state, user) => (state.user = user),
    // userLoading: (state, loading) => (state.userLoading = loading)
  },
  getters: {
    authenticatedUserName: state => state.authenticatedUser && dicoLabelsService.formatName(state.authenticatedUser),
    actionUpdateOrderShippingDate: state =>
      checkUserAccess(state.authenticatedUser, [UserRoleType.ACTION_UPDATE_ORDER_SHIPPING_DATE]),
    actionAcceptReturnPayment: state =>
      checkUserAccess(state.authenticatedUser, [UserRoleType.ACTION_ACCEPT_RETURN_PAYMENT]),
    isAdmin: state => checkUserAccess(state.authenticatedUser, [UserRoleType.ADMIN])
    // isPreparationMaster: state => checkUserAccess(state.authenticatedUser, [UserRoleType.PREPARATION_MASTER]),
    // isShippingMaster: state => checkUserAccess(state.authenticatedUser, [UserRoleType.SHIPPING_MASTER]),
    // canManageWithinSection: (state, _getters, _rootState, rootGetters) => {
    //   if (!rootGetters['app-section/activeSection'] && !checkUserAccess(state.authenticatedUser, [UserRoleType.ADMIN]))
    //     return;
    //   return (
    //     checkUserAccess(state.authenticatedUser, [UserRoleType.TECHNICAL_ALL_MANAGER]) ||
    //     checkUserAccess(state.authenticatedUser, [UserRoleType.TECHNICAL_SELF_MANAGER], {
    //       currentSection: rootGetters['app-section/activeSection'].code
    //     }) ||
    //     checkUserAccess(state.authenticatedUser, [UserRoleType.ADMIN])
    //   );
    // },
  }
};

export default options;
